import { useAppSelector } from '@/store/hooks'

import { selectCurrentUser } from '../selectors'
import type { CurrentUser } from '../types'

/**
 * The signed-in user from this tab's session. Synchronous: the session and directory live in Redux, so `data` is
 * undefined only when nobody is signed in.
 */
export function useCurrentUser(): { data: CurrentUser | undefined } {
  return { data: useAppSelector(selectCurrentUser) ?? undefined }
}
